import React, {memo, useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {setupDataSelector} from 'src/modules/profile/account/tabs/admin-account-api-v2/views/controllers/setup/services/selectors';
import {getSettings} from 'src/openapi/admin/apis/SettingsControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import {SecondaryTabs, Tab} from '@pb/kit-component-tabs-v2';


import {API_TABS} from '../contants';
import {setAccountId} from '../services/account-id/actions';

import {apiV2, apiV2Tabs, microappFrame} from './tabs-structure.module.styl';

type Props = {
    accountId: number,
    activeTab: string,
    children: React.ReactElement,
};

export const TabsStructure = memo<Props>(({accountId, children, activeTab}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const apiDispatch = useAppDispatch();
    const setupData = useSelector(setupDataSelector);

    useEffect(() => {
        if (accountId) {
            dispatch(setAccountId(accountId));
            if (!setupData) {
                apiDispatch(getSettings({accountId}));
            }
        }
    }, [accountId, apiDispatch, dispatch, setupData]);

    const onTabChange = useCallback((tab: string) => {
        navigate(`/profile/account/${accountId}/api/${tab}`);
    }, [accountId, navigate]);

    return (
        <div className={`${microappFrame} ${apiV2} microapp-frame api-v2`}>
            <SecondaryTabs className={`${apiV2Tabs} api-v2__tabs`} value={activeTab} onChange={onTabChange} style={{width: '100%'}}>
                <Tab value={API_TABS.SETUP.name} {...API_TABS.SETUP}/>
                <Tab value={API_TABS.PRICING.name} {...API_TABS.PRICING}/>
                <Tab value={API_TABS.ALERTS.name} {...API_TABS.ALERTS}/>
                <Tab value={API_TABS.LIMITS.name} {...API_TABS.LIMITS}/>
                <Tab value={API_TABS.CALLS.name} {...API_TABS.CALLS}/>
                <Tab value={API_TABS.RELEASE_NOTES.name} {...API_TABS.RELEASE_NOTES}/>
            </SecondaryTabs>
            {children}
        </div>
    );
});
